// src/components/store/sections/gallery/GalleryV62PolaroidwallCoralFlame.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV62PolaroidwallCoralFlame(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={62}
      archKey="polaroid_wall"
      archLabel="Polaroid Washi Wall"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f97316"
      {...props}
    />
  );
}
